import {getDefaultState} from '../../models';
import * as ActionTypes from '../actions/action-types';

const MutliSelectAnswersReducer = function(state = getDefaultState().multiSelectAnswers, action: any) {
    switch(action.type) {
        case ActionTypes.MULTI_SELECT_ANSWERS_ADD_NEW:
            const len = state.multiSelectAnswersList.length;
            // 65 is charcode for 'A'
            const nextId = String.fromCharCode(65 + len);
            const emptyAnswer = {
                id: nextId, title: '', correct: false, selectedFeedback: "", unselectedFeedback: "", answer: ""
            };
            return {
                ...state,
                multiSelectAnswersList: state.multiSelectAnswersList.concat([emptyAnswer])
            };
        case ActionTypes.MULTI_SELECT_ANSWERS_REMOVE:
            const newMultiSelectAnswersList = state.multiSelectAnswersList.filter((multi: any) => multi.id !== action.id);
            const newGroupFeedbackList = state.groupFeedbackList.map((feedback: any) => {
                feedback.answers = feedback.answers.filter((ans: any) => {
                    const answerIndex = newMultiSelectAnswersList.filter((el: any) => el.id === ans)[0];
                    return newMultiSelectAnswersList.indexOf(answerIndex) !== -1;
                });
                return feedback;
            });
            return {
                ...state,
                groupFeedbackList: newGroupFeedbackList,
                multiSelectAnswersList: newMultiSelectAnswersList,
            };
        case ActionTypes.MULTI_SELECT_ANSWERS_CHANGED:
            let numberOfCorrects = 0
            for (const multi of state.multiSelectAnswersList) {
                if (multi.correct) numberOfCorrects += 1;
            }
            return {
                ...state,
                multiSelectAnswersList: state.multiSelectAnswersList.map((multi: any) => {
                    if (multi.id === action.id) {
                        return {
                            id: action.id,
                            title: action.title,
                            correct: (numberOfCorrects === 1 && multi.correct) ? true : action.correct,
                            selectedFeedback: action.selectedFeedback,
                            unselectedFeedback: action.unselectedFeedback,
                            answer: action.answer
                        }
                    } else {
                        return multi;
                    }
                })
            };
        // GroupFeedback
        case ActionTypes.GROUP_FEEDBACK_CHANGE:
            let groupFeedbackList = state.groupFeedbackList.map((el: any) => {
                if (el.id === action.id) {
                    return {...action};
                } else {
                    return el;
                }
            });
            return {
                ...state,
                groupFeedbackList: groupFeedbackList
            };
        case ActionTypes.GROUP_FEEDBACK_ADD:
            return {
                ...state,
                groupFeedbackList: state.groupFeedbackList.concat([{
                    answers: [],
                    feedback: '',
                    id: state.groupFeedbackList.length
                }])
            };
        case ActionTypes.GROUP_FEEDBACK_REMOVE:
            return {
                ...state,
                groupFeedbackList: state.groupFeedbackList.filter((el: any) => {
                    return el.id !== action.id;
                }).map((el: any, ind: number) => {el.id = ind; return el;})
            };
        default:
            return state;
    }
};

export default MutliSelectAnswersReducer;
